import {Paragraph, Spinner} from 'grommet'


export default function LoadingSpinner() {
  return (
    <Paragraph size="large" margin="large">
      <Spinner size="medium" />
    </Paragraph>
  )
}
